module.exports = __webpack_public_path__ + "static/media/BuenosAiresWeb-Light.d61b4821.woff2";